import React from 'react';
import PuzzleCheckbox from '../../UI/checkbox/PuzzleCheckbox';
import { CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import CellAbstract from './CellAbstract';
import { CELL_CHECKBOX_PROPS } from './Types';

class CellCheckbox extends CellAbstract<CELL_CHECKBOX_PROPS, {}> {
  private onChange = ({ value }: CheckboxChangeEvent) => {
    const {
      dataItem,
      dataIndex,
      field,
      updateRecord,
      onCellCheckboxChange,
      cellConfig
    } = this.props;
    const columnField = (field || dataIndex);
    updateRecord({
      ...dataItem,
      [columnField]: value
    });
    onCellCheckboxChange && onCellCheckboxChange(value, dataIndex);
    cellConfig?.onChangeSingle && cellConfig.onChangeSingle(value, field, dataItem);
  };

  render() {
    const {
      cellConfig,
      dataIndex,
      dataItem,
      field
    } = this.props;
    const checked = dataItem[(field || dataIndex)];
    const disabled = dataItem.disabled || cellConfig?.disabled
        || (cellConfig?.disabledPropName && dataItem[cellConfig?.disabledPropName]);

    return this.renderCell(
      <PuzzleCheckbox
        checked={checked}
        onChange={this.onChange}
        tabIndex={0}
        disabled={disabled}
        appearance={cellConfig?.appearance}
      />
    );
  }
}

export default CellCheckbox;
